import {
  FETCH_BOOTH_LISTING_SUCCESS,
  FETCH_BOOTH_LISTING_FAILURE,
  RESET,
} from "./boothTypes";

const initialState = {
  allBooths: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOTH_LISTING_SUCCESS:
      return {
        allBooths: action.payload,
        error: null,
      };
    case FETCH_BOOTH_LISTING_FAILURE:
      return {
        allBooths: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
